import { useMemo } from "react";
import { Tooltip } from "antd";
import { TooltipPropsWithTitle } from "antd/es/tooltip";

interface FormattedTooltipProps extends Omit<TooltipPropsWithTitle, "title"> {
	title?: string;
}

/** This tooltip converts a string with "\n" into JSX with line breaks. */
export const UIMultilineTooltip = ({ title, children, ...props }: FormattedTooltipProps) => {
	const formattedTitle = useMemo(
		() => (
			<>
				{title?.split("\n").map((line, index) => (
					// eslint-disable-next-line react/no-array-index-key
					<span key={index} className="block">
						{line}
					</span>
				))}
			</>
		),
		[title]
	);

	if (!title) return <>{children}</>;

	return (
		<Tooltip title={formattedTitle} {...props}>
			{children}
		</Tooltip>
	);
};
